export default {
  validate (propertyBicycleLaptopValue) {
    return {
      required: true,
      valid: Number(propertyBicycleLaptopValue) > 0 && Number(propertyBicycleLaptopValue) <= Number(this.constants.SPECIFIC_ITEM_VALUE_MAX),
    };
  },
  message: 'Please enter a number between 1 and 999999.',
  computesRequired: true,
};
